// Evaluering av prediksjonsloggen: sammenlign hver logget prediksjon med faktisk sluttkurs på måldatoen.

const nyDay = d => d.toLocaleDateString("en-CA", { timeZone: "America/New_York" });
const nyHour = d => +d.toLocaleString("en-US", { timeZone: "America/New_York", hour: "numeric", hourCycle: "h23" });

// Returnerer evaluerte prediksjoner (nyeste først): err = avvik i %, naive = avvik for «kursen står stille», dirOk = riktig retning.
export function evalPredictions(predLog, techData, now = new Date()) {
  const today = nyDay(now), h = nyHour(now), out = [];
  for (const e of predLog) {
    if (!(e.target < today || (e.target === today && h >= 17))) continue;
    const td = techData[e.ticker];
    if (!td?.timestamps) continue;
    const i = td.timestamps.findIndex(ts => nyDay(new Date(ts * 1000)) === e.target);
    const act = i >= 0 ? td.closes[i] : null;
    if (!act) continue;
    out.push({
      ...e, actual: act,
      err: Math.abs(e.pred - act) / act * 100,
      naive: Math.abs(e.cp - act) / act * 100,
      dirOk: e.pred !== e.cp && act !== e.cp ? (e.pred > e.cp) === (act > e.cp) : null,
    });
  }
  return out.sort((a, b) => b.target.localeCompare(a.target));
}
